export enum SelectEvent {
  INPUT = 'input',
  SELECTION = 'selection'
}
